import React from 'react';
import SubcategoriaMenu from './subcategoria_menu';

export default class CategoriaMenu extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            visible: false
        }
        this.visualizarCategoria = this.visualizarCategoria.bind(this);
    }

    visualizarCategoria(event){
        event.preventDefault();
        this.setState({
            visible: !this.state.visible
        })
    }

    render(){
        return(
            <li>
                <h5 onClick={this.visualizarCategoria}>
                    <i className={this.props.icono_categoria} aria-hidden="true"></i>{this.props.nombre_categoria}<span className="arrow"></span>
                </h5>      
                <ul className={this.state.visible?'visible sub-menu': 'no-visible sub-menu'}>
                    {this.props.subCategorias.map((subCateg)=> {                        
                        return <SubcategoriaMenu key={subCateg.CodigoMenu} nombre_subCateg={subCateg.NombreMenu} items={subCateg.ItemsMenu}/>
                    })}
                </ul>
            </li>
        );
  }
}

